import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1f5f4306&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=1f5f4306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f4306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5f4306')) {
      api.createRecord('1f5f4306', component.options)
    } else {
      api.reload('1f5f4306', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=1f5f4306&scoped=true&", function () {
      api.rerender('1f5f4306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/core/profile-circle/component.vue"
export default component.exports